<template>
  <div class="app flex-row align-items-center">
    <b-button @click="f_printFunction()">print</b-button>
    <div ref="print_area" class="container">
      <b-row>
        <b-col cols="5">
          <hr/>
          {{ d_billData.shop_name }} <br/>
          {{ d_billData.shop_address }} <br/>
          Tel: {{ d_billData.shop_phone_number }} <br/>
          <!-- Web Sitesi: {{ d_billData.web_address }} <br/> -->
          <!-- E-Posta: {{ d_billData.shop_mail }} <br/> -->
          Vergi Dairesi: {{ d_billData.shop_tax_office }} <br/>
          VKN: {{ d_billData.shop_tax_number }} <br/>
          <hr/>
          <hr/>
          <strong>{{ StoreLangTranslation.data['dear'][StoreLang] }}</strong><br/>
          {{ d_billData.user_bill_name }} <br/>
          {{ d_billData.user_address }} <br/>
          Tel: {{ d_billData.user_phone_number }} <br/>
          <!-- Web Sitesi: {{ d_billData.web_address }} <br/> -->
          <!-- E-Posta: {{ d_billData.shop_mail }} <br/> -->
          Vergi Dairesi: {{ d_billData.user_tax_office }} <br/>
          VKN: {{ d_billData.user_tax_number }} <br/>
          <hr/>
        </b-col>
        <b-col cols="7">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <table class="table table-bordered table-sm">
            <thead style="background-color: #f2f2f2;">
              <tr>
                <th>Sıra No</th>
                <th>Mal Hizmet</th>
                <th>Miktar</th>
                <th>Birim Fiyat</th>
                <th>KDV Oranı</th>
                <th>KDV Tutarı</th>
                <th>Mal Hizmet Tutarı</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, product_index) in d_billData.product_list">
                <td>{{product_index + 1}}</td>
                <td>{{product.product_name}}</td>
                <td>{{product.product_count}} Adet</td>
                <td>{{product.price_without_tax}} {{d_currencyTypes[product.cur_type]}}</td>
                <td>%{{product.tax_rate_percent}}</td>
                <td>{{product.price_tax}} {{d_currencyTypes[product.cur_type]}}</td>
                <td>{{product.price_without_tax}} {{d_currencyTypes[product.cur_type]}}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <hr/>
      <b-row>
        <b-col cols="7"></b-col>
        <b-col cols="5">
          <table class="table table-bordered table-sm">
            <tbody>
              <tr>
                <td>Mal Hizmet Toplam Tutarı</td>
                <td class="text-right">{{d_billData.total_price}} {{d_currencyTypes[d_billData.user_active_cur]}}</td>
              </tr>
              <tr>
                <td>Toplam İskonto</td>
                <td class="text-right">{{d_billData.total_discount}} {{d_currencyTypes[d_billData.user_active_cur]}}</td>
              </tr>
              <tr>
                <td>Hesaplanan Katma Değer Vergisi</td>
                <td class="text-right">{{d_billData.total_tax}} {{d_currencyTypes[d_billData.user_active_cur]}}</td>
              </tr>
              <tr>
                <td>Vergiler Dahil Toplam Tutar</td>
                <td class="text-right">{{d_billData.total_price_with_tax}} {{d_currencyTypes[d_billData.user_active_cur]}}</td>
              </tr>
              <tr style="background-color: #f2f2f2;">
                <th>Ödenecek Tutar</th>
                <th class="text-right">{{d_billData.amount_to_be_paid}} {{d_currencyTypes[d_billData.user_active_cur]}}</th>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" lg="6">
          {{ StoreLangTranslation.data['pdf_file'][StoreLang] }}
          <b-spinner v-if="d_docLoading['pdf_doc_id']" small variant="primary" label="Continuing"></b-spinner>
          <i v-else-if="d_billData.pdf_doc_id" class="fa fa-check" style="color: green;"></i>
          <i v-else class="fa fa-exclamation-triangle" style="color: #ffbb00;"></i>
          <b-form-file
            v-model="d_tmpFilePdf"
            accept=".pdf,application/pdf"
            @input="f_addPdfFileToDocuments(d_tmpFilePdf)"
            :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
            :placeholder="StoreLangTranslation.data['select_bill_file'][StoreLang]"
            style="margin-bottom: 5px;"
            :disabled="d_docLoading['pdf_doc_id']"
          ></b-form-file>
        </b-col>
        <b-col sm="12" lg="6">
          {{ StoreLangTranslation.data['xml_file'][StoreLang] }}
          <b-spinner v-if="d_docLoading['xml_doc_id']" small variant="primary" label="Continuing"></b-spinner>
          <i v-else-if="d_billData.xml_doc_id" class="fa fa-check" style="color: green;"></i>
          <i v-else class="fa fa-exclamation-triangle" style="color: #ffbb00;"></i>
          <b-form-file
            v-model="d_tmpFileXml"
            accept=".xml,application/xml,text/xml"
            @input="f_addXmlFileToDocuments(d_tmpFileXml)"
            :browse-text="StoreLangTranslation.data['select_file'][StoreLang]"
            :placeholder="StoreLangTranslation.data['select_bill_file'][StoreLang]"
            style="margin-bottom: 5px;"
            :disabled="d_docLoading['xml_doc_id']"
          ></b-form-file>
        </b-col>
      </b-row>
    </div>
    <hr/>

    <div>
      <b-row>
        <b-col sm="12" lg="10"></b-col>
        <b-col sm="12" lg="2">
          <b-button @click="f_saveBill()" style="width: 100%; margin: 10px;" variant="outline-success" :disabled="d_docLoading['xml_doc_id'] || d_docLoading['pdf_doc_id']">
            <i class="fa fa-floppy-o"></i>
            {{ StoreLangTranslation.data['save'][StoreLang] }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { ClsRoute } from '@/wam/modules/route';
import { ServiceFunctions } from '@/wam/modules/service';
import { mapGetters } from 'vuex';
const htmlTemplate = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  
  <style type="text/css">
      @page {
        size: A4;
        margin: 10mm 8mm 10mm 8mm;
      }
    @media print {
      .new_css_class_use_test {
          width: 100%;
          display: inline-block;
      }

      html, body {
        width: 210mm;
        background: white!important;
        height: 297mm;
      }

      body {
        -webkit-print-color-adjust: exact; /* Chrome, Safari */
        print-color-adjust: exact; /* Firefox */
      }
    }

    .printProjectTeamDiv {
    page-break-before: always;
    }

    .printTableDiv table, 
    .printTableDiv td, 
    .printTableDiv tr, 
    .printTableDiv th {
        border: 1px solid black;
    }


    .header, .header-space {
      height: 60px;
      width: 100%;
    }
    .header {
      position: fixed;
      top: 0;
    }
    .footer {
      position: fixed;
      bottom: 0;
    }
    table{
      width: 100%;
    }

    ##CSS##
  </style>

</head>
<body>
  
  <div>
        <table>
          <thead>
            <tr>
              <td>
                <div class="header-space">&nbsp;</div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">##BODY##</div>
              </td>
            </tr>
          </tbody>
        </table>
        
  </div>
</body>
</html>
`;
export default {
  name: 'BillDetails',
  computed: mapGetters({
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreDevice: 'StoreDevice',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  props: {
    p_billData: {
      type: Object,
      required: true
    }
    // d_billData: {
    //     'shop_client_id': '',
    //     'shop_name': '',
    //     'shop_address': '',
    //     'shop_tax_office': '',
    //     'shop_tax_number': '',
    //     'shop_phone_number': '',
    //     'total_price': '',
    //     'total_price_with_txt': '',
    //     'product_list': [],
    //     'bill_name': '',
    //     'pdf_doc_id': '',
    //     'xml_doc_id': '',
    //     'user_address': '',
    //     'user_bill_name': '',
    //     'user_username': '',
    //     'user_phone_number': '',
    //     'user_tax_office': '',
    //     'user_tax_number': '',
    //     'user_active_lang': '',
    //     'user_active_cur': '',
    //     'total_discount': '',
    //     'total_tax': '',
    //     'total_price_with_tax': '',
    //     'amount_to_be_paid': '',
    //   },
    //   d_billProductItem: {
    //     'product_name': '',
    //     'product_count': '',
    //     'product_unit_price': '',
    //     'product_total_price': '',
    //     'product_client_id': '',
    //     'payment_client_id': '',
    //     'tax_rate_percent': '',
    //     'is_price_includes_tax': '',
    //     'price_with_tax': '',
    //     'price_without_tax': '',
    //     'price_tax': '',
    //   },
  },
  data () {
    return {
      d_billData: {},
      d_currencyTypes: {
        '0': 'TL',
        '1': 'USD'
      },
      d_docLoading: {
        'pdf_doc_id': false,
        'xml_doc_id': false,
      },
      d_tmpFilePdf: null,
      d_tmpFileXml: null,
      d_saveLoading: false,
    };
  },
  created: function () {
    // this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_billData = this.p_billData;
    this.f_calculateAllProducts();
  },
  mounted: function () {
    //
  },
  methods: {
    f_printFunction: function () {
      let organizationCreatedDate = '';
      let organizationCreatedDateFormatted = '';
      let organizationLabel = '';
      let organizationId = '';
      let d_printLabels = '';
      let d_printLang = '';
      let formattedDate = '';
      let footer_replace = "";
      let header_replace = `
        <div>
          <div style="position: absolute; top: 0px; left: 0px;">
            <p style="font-size: 16px;">Fatura</p>
          </div>
        </div>
      `;


      let w = window.open('', '_blank', 'height=750, width=1000, toolbar=0, menubar=0, left=100, top=30');
      let pageHtml = htmlTemplate;
      // pageHtml = pageHtml.replace('##HEADER##', header_replace);
      // let cover_replace = `
      //   <div style="display: flex; justify-content: center; align-items: center; text-align: center; height: 100vh; flex-direction: column; font-size: 24px;">
      //     <strong>WisdomEra</strong>
      //     <strong>${organizationLabel}</strong>
      //     <strong>${d_printLabels.title[d_printLang]}</strong>
      //     <strong>Proje Id: ${organizationId}</strong>
      //     <strong>(${formattedDate})</strong>
      //   </div>
      // `;
      // pageHtml = pageHtml.replace('##COVER##', cover_replace);
      // let title_html = `${d_printLabels.documentTitle[d_printLang]} ${organizationId} - ${organizationLabel}`
      // pageHtml = pageHtml.replace('##TITLE##', title_html);
      let body_html = '<div style="padding: 10px;">';
      body_html += this.$refs.print_area.innerHTML;
      body_html += '</div>';
      pageHtml = pageHtml.replace('##BODY##', body_html);
      // pageHtml = pageHtml.replace('##FOOTER##', footer_replace);
      w.document.write(pageHtml);
      w.document.close();
      w.onload = function () {
        w.focus();
        w.print();
      };
    },
    f_addPdfFileToDocuments: function (file) {
      if (file) {
        // console.log(file);
        let file_name = file.name;
        let arr = file.name.split('.');
        let fileExtension = arr[arr.length - 1];
        if (["pdf"].indexOf(fileExtension.toLowerCase()) === -1) {
          file = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_extension_type_is_not_eligible'][this.StoreLang]);
          return;
        }
        if (file.size > 10485760) {
          file = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang], ' : ', file.size);
          return;
        }
        var reader = new FileReader();
        var vm = this;
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          // console.log(reader.result);
          // console.log('page_info_index ', page_info_index);
          // console.log('page_info_detail_index ', page_info_detail_index);
          // console.log('vm.d_frdWebunitData.page_info ', vm.d_frdWebunitData.page_info);
          // console.log('reader.result; ', reader.result);
          vm.f_documentRecord(reader.result, fileExtension, 'pdf_doc_id');
          vm.$forceUpdate();
        }, false);
        reader.readAsDataURL(file);
        this.$forceUpdate();

      }
    },
    f_addXmlFileToDocuments: function (file) {
      if (file) {
        // console.log(file);
        let file_name = file.name;
        let arr = file.name.split('.');
        let fileExtension = arr[arr.length - 1];
        if (["xml"].indexOf(fileExtension.toLowerCase()) === -1) {
          file = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_extension_type_is_not_eligible'][this.StoreLang]);
          return;
        }
        if (file.size > 10485760) {
          file = null;
          this.$forceUpdate();
          alert(this.StoreLangTranslation.data['file_size_is_not_eligible'][this.StoreLang], ' : ', file.size);
          return;
        }
        var reader = new FileReader();
        var vm = this;
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          // console.log(reader.result);
          // console.log('page_info_index ', page_info_index);
          // console.log('page_info_detail_index ', page_info_detail_index);
          // console.log('vm.d_frdWebunitData.page_info ', vm.d_frdWebunitData.page_info);
          // console.log('reader.result; ', reader.result);
          vm.f_documentRecord(reader.result, fileExtension, 'xml_doc_id');
          vm.$forceUpdate();
        }, false);
        reader.readAsDataURL(file);
        this.$forceUpdate();

      }
    },
    f_documentRecord: function (file_data, file_type, var_name) {
      this.d_docLoading[var_name] = true;
      let query = 'user_client_id=' + this.d_billData['user_username'];
      query += '&file_path=bills';
      // query += '&layer_client_id=';
      query += '&layer_code=usr_bill';
      let data = {
        'file': file_data,
        'file_type': file_type
      };
      ServiceFunctions.document_record_to_db(query, data)
        .then(resp_record => {
          this.d_docLoading[var_name] = false;
          if (resp_record.data.status_code.substring(resp_record.data.status_code.length - 3, resp_record.data.status_code.length) == '000') {
            if (resp_record.data.doc_id) {
              // 'pdf_doc_id'
              this.d_billData[var_name] = resp_record.data.doc_id;
            }

          } else {
            let txt = 'status_code = ' + resp_record.data.status_code + '\n';
            txt += 'status_message = ' + resp_record.data.status_message;
            alert(txt);
          }
        });
    },
    f_saveBill: function () {
      let approve = false;
      if (!this.d_billData['pdf_doc_id'] && !this.d_billData['xml_doc_id']) {
        if (confirm(this.StoreLangTranslation.data['empty_pdf_and_xml_doc_id'][this.StoreLang])) {
          approve = true;
        }
      } else if (!this.d_billData['pdf_doc_id']){
        if (confirm(this.StoreLangTranslation.data['empty_pdf_doc_id'][this.StoreLang])) {
          approve = true;
        }
      } else if (!this.d_billData['xml_doc_id']){
        if (confirm(this.StoreLangTranslation.data['empty_xml_doc_id'][this.StoreLang])) {
          approve = true;
        }
      } else {
        approve = true;
      }
      if (approve) {
        this.d_saveLoading = true;
        let query = 'user_client_id=' + this.d_billData['user_username'];
        query += '&shop_client_id=' + this.d_billData['shop_client_id'];
        let data = {
          'bill_data': this.d_billData,
        };
        // console.log(data)
        ServiceFunctions.user_bill_new(query, data)
          .then(resp => {
            this.d_saveLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['operation_completed'][this.StoreLang]);
            } else {
              let txt = 'status_code = ' + resp.data.status_code + '\n';
              txt += 'status_message = ' + resp.data.status_message;
              alert(txt);
            }
          });
      }
    },
    f_calculateAllProducts: function () {
      this.d_billData.total_price = 0;
      this.d_billData.total_discount = 0;
      this.d_billData.total_tax = 0;
      this.d_billData.total_price_with_tax = 0;
      this.d_billData.amount_to_be_paid = 0;
      for (let i in this.d_billData.product_list) {
        try {
          this.d_billData.total_price += parseFloat(this.d_billData.product_list[i]['price_without_tax']);
        } catch {}
        try {
          // this.d_billData.total_discount = parseFloat(this.d_billData.total_discount) + parseFloat(this.d_billData.product_list[i]['discount']);
          let product_discount = parseFloat(this.d_billData.product_list[i]['discount']);
          if (!isNaN(product_discount)) {
            this.d_billData.total_discount = parseFloat(this.d_billData.total_discount) + product_discount;
          }
        } catch {}
        try {
          this.d_billData.total_tax += parseFloat(this.d_billData.product_list[i]['price_tax']);
        } catch {}
        try {
          this.d_billData.total_price_with_tax += parseFloat(this.d_billData.product_list[i]['price_with_tax']);
        } catch {}
        try {
          this.d_billData.amount_to_be_paid += parseFloat(this.d_billData.product_list[i]['price_with_tax']);
        } catch {}
      }
      this.d_billData.total_price = String(this.d_billData.total_price.toFixed(2));
      this.d_billData.total_discount = String(this.d_billData.total_discount);
      this.d_billData.total_tax = String(this.d_billData.total_tax.toFixed(2));
      this.d_billData.total_price_with_tax = String(this.d_billData.total_price_with_tax.toFixed(2));
      this.d_billData.amount_to_be_paid = String(this.d_billData.amount_to_be_paid.toFixed(2));
    }
  }
}
</script>